// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonEditEdit_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.68423 8.87868L0.977126 11L3.09845 10.2929L9.46241 3.92893L8.04819 2.51472L1.68423 8.87868ZM8.7553 1.80761L9.81596 0.746952L11.2302 2.16117L10.1695 3.22183L8.7553 1.80761Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56066 12.3161L0.5 15.4981L3.68198 14.4375L12.8744 5.24508L10.753 3.12376L1.56066 12.3161ZM11.4602 2.41665L12.8744 1.00244L14.9957 3.12376L13.5815 4.53798L11.4602 2.41665Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.26777 17.9041L1.5 22.5003L6.09619 20.7325L19.1777 7.65107L16.3492 4.82264L3.26777 17.9041ZM17.7635 3.40843L19.8848 1.28711L22.7132 4.11554L20.5919 6.23686L17.7635 3.40843Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.56464 25.1921L0 32L6.76438 29.5023L26.6063 9.63571L22.3636 5.39307L2.56464 25.1921ZM24.485 3.27175L27.3134 0.443495L31.556 4.68614L28.7276 7.51439L24.485 3.27175Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.17241 31.8552L0 40.0001L8.12521 36.8018L32.8238 12.0036L27.8641 7.06387L3.17241 31.8552ZM30.6868 4.22978L34.2156 0.687492L39.1746 5.62669L35.6469 9.16981L30.6868 4.22978Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonEditEdit is a generated icon component.
 */
let IconCommonEditEdit = IconCommonEditEdit_1 = class IconCommonEditEdit extends IconBaseElement {
    render() {
        return html `${IconCommonEditEdit_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonEditEdit.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconCommonEditEdit = IconCommonEditEdit_1 = __decorate([
    customElement('zui-icon-common-edit-edit')
], IconCommonEditEdit);
export { IconCommonEditEdit };
